// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__eUQL3","text":"styles_text__WC9rC"};